export enum NextPrevChartNames {
  NEXT = 'next',
  PREV = 'prev',
}

export enum FeedbackCategoryName {
  FOOD = 'Food',
  ACCOMMODATION = 'Accommodation',
  THICKET = 'Ticket',
  FREE_FORM = 'Free form',
}

export enum UserTabs {
  ACTIVE_TRIP = 'activeTrip'
}